import { render } from "./NumberField.vue?vue&type=template&id=c965ce38&ts=true"
import script from "./NumberField.vue?vue&type=script&lang=ts"
export * from "./NumberField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__